// src/api/createChatRequest.js
import { request } from './authenticatedClient';

/**
 * Create a chat request with minimal repetition.
 * @param {object} requestBody - The request payload.
 * @param {string} endpoint - The server endpoint (e.g. "/chataudio/openai").
 * @param {AbortSignal} [abortSignal] - optional
 * @returns {Promise<Response>}
 */
export async function createChatRequest(requestBody, endpoint, abortSignal) {
  // The only thing we specify: body, endpoint, signal
  return request(endpoint, {
    body: requestBody,
    signal: abortSignal,
    skipBodyLogging: true,
  });
}
